import { type FC } from 'react';
import { toast } from 'react-toastify';
import { useIsMutating } from '@tanstack/react-query';

import { useActiveSavedView } from '../hooks/useActiveSavedView';
import { UPDATE_SAVED_VIEW_MUTATION_KEY, useUpdateSavedView } from '../hooks/useSavedViewMutations';
import { SavedViewActiveHeader } from '../views/SavedViewActiveHeader';

export const SavedViewActiveHeaderController: FC = () => {
  const activeView = useActiveSavedView();
  const { mutate } = useUpdateSavedView();
  // Same guard as Save changes: a rename PUT composed from the cached view while another
  // update is in flight would revert that update's filters (full-state PUT, last writer wins).
  const isUpdating = useIsMutating({ mutationKey: UPDATE_SAVED_VIEW_MUTATION_KEY }) > 0;

  if (!activeView) return null;

  const handleRename = (name: string) =>
    mutate(
      { id: activeView.id, name, filters: activeView.filters },
      { onSuccess: () => toast.success('Filtered view renamed'), onError: () => toast.error('Unable to rename view') },
    );

  // key resets in-progress rename state when the active view changes — otherwise a draft
  // started on one view would be applied to the next one selected from the nav
  return (
    <SavedViewActiveHeader
      key={activeView.id}
      name={activeView.name}
      updatedAt={activeView.updated_at}
      isSaving={isUpdating}
      onRename={handleRename}
    />
  );
};
